<template>
  <div>
    <div class="bg" v-if="show === 1" @click="showDrop"></div>
    <div class="drop-down" @click="showDrop">
      <div>{{title}}</div>
      <i class="icon-font" :style=[iconStyle]>&#xe61c;</i>
      <transition name="fade">
        <div class="drop-down-content" :style=[style] :class="{'up': show === 1, 'down': show === 0}">
          <div class="drop-down-list" v-for="(data,index) in items" :key="index" @click="sendContent(data,index)">
            <div class="drop-down-list-item">{{data.title}}</div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropDownNext',
  data () {
    return {
      canClick: true,
      title: this.content,
      show: null,
      style: {
        borderBottom: 'none'
      },
      iconStyle: {}
    }
  },
  props: ['content', 'items', 'dropStyle', 'changeTitle'],
  methods: {
    showDrop: function () {
      if (this.canClick) {
        if (this.show === null) {
          this.show = 1
        } else {
          this.show = this.show === 0 ? 1 : 0
        }
        this.iconStyle.transform = this.show === 1 ? 'rotate(90deg)' : 'rotate(0)'
        if (this.show === 1) {
          this.style = {borderBottom: 'solid 1px #3b79a1'}
        } else {
          this.canClick = false
          let _this = this
          setTimeout(function () {
            _this.style = {borderBottom: 'none'}
            _this.canClick = true
          }, 500)
        }
      }
    },
    sendContent: function (data, index) {
      this.$emit('sendInfo', data)
    }
  },
  watch: {
    '$route' () {
      this.show = null
    }
  },
  destroyed () {
    this.show = null
  }
}
</script>

<style scoped>
  .drop-down{
    text-align: left;
    width: 13vw;
    height: 2.43vw;
    padding: 0.63vw;
    font-size: 0.83vw;
    color: #00d2ff;
    border: solid 0.05vw #3b79a1;
    margin-right: 1vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 1000;
  }
  .bg{
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: transparent;
    top: 0;
    left: 0;
    z-index: 998;
  }
  .drop-down:hover{
    border: solid 0.05vw #00d2ff;
    box-shadow: 0 0 0.2vw #1fb5ac;
    cursor: pointer;
  }
  .icon-font{
    color: #3b79a1;
    position: absolute;
    right: 0.63vw;
    top: 0.68vw;
    transition: all .3s ease-in;
    margin-right: 0 !important;
    margin-top: 0 !important;
  }
  .drop-down:hover > i{
    color: #00d2ff;
  }
  .drop-down-content{
    position: absolute;
    width: 13vw;
    height: 0;
    overflow: auto;
    left: -0.05vw;
    top: 2.38vw;
    background-color: #1d2454;
    border: solid 1px #3b79a1;
    border-top: none;
    z-index: 999;
  }
  .drop-down-list{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    z-index: 2;
    flex-direction: column;
  }
  .drop-down-list-item{
    width: 100%;
    padding: 0.9vw 0.63vw;
  }
  .drop-down-list-item:hover{
    background: #474e7f;
  }
  /*.fade-enter-active,.fade-leave-active{*/
    /*transition: all 0.5s ease-out;*/
  /*}*/
  /*.fade-enter{*/
    /*transform: translateY(0);*/
    /*opacity: 0;*/
    /*height: 0;*/
  /*}*/
  /*.fade-leave-active{*/
    /*transform: translateY(0);*/
    /*opacity: 0;*/
    /*height: 0;*/
  /*}*/
  .up{
    animation:upSile .5s forwards;
    -moz-animation:upSile .5s forwards; /* Firefox */
    -webkit-animation:upSile .5s forwards; /* Safari and Chrome */
    -o-animation:upSile .5s forwards; /* Opera */
  }
  .down{
    animation:downSile .5s forwards;
    -moz-animation:downSile .5s forwards; /* Firefox */
    -webkit-animation:downSile .5s forwards; /* Safari and Chrome */
    -o-animation:downSile .5s forwards; /* Opera */
  }
  @keyframes upSile {
    from{
      height: 0;
    }
    to{
      height: 6vw;
    }
  }
  @keyframes downSile {
    from{
      height: 200%;
    }
    to{
      height: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DropDownNext.vue